"use client";

import React from "react";
var __jsx = React.createElement;
import { cn } from "@lib/cn";
import Image from "next/image";
export function ImageRender(_ref) {
  let {
    src,
    alt,
    width,
    height,
    className,
    onClick,
    useImage = true
  } = _ref;
  return src ? __jsx("div", {
    className: cn([className, onClick ? "cursor-pointer" : ""]),
    onClick: onClick ? onClick : () => {}
  }, useImage ? __jsx(Image, {
    src: src,
    alt: alt,
    width: width,
    height: height,
    className: className
  }) : __jsx("img", {
    src: src,
    alt: alt,
    width: width,
    height: height,
    className: className
  })) : __jsx(React.Fragment, null);
}
export default ImageRender;